import styled from "styled-components";
export const StyledInput = styled.input `
  position: absolute;
  opacity: 0;
  cursor: pointer;
  width: 100%;
  height: 100%;
`;
export const StyledRadio = styled.div `
  position: relative;
  width: fit-content;
  cursor: ${({ isDisabled, isError }) => isDisabled || isError ? "unset" : "pointer"};
  svg {
    pointer-events: none;
  }
`;
//# sourceMappingURL=Radio.style.js.map